export const environment = {
  production: false,
  environmentName: 'development',
  apiUrl: 'https://webshop-b2b-api-dev.yllw.com',
  apiVersion: 'v1',
  enableDebugMode: true,
  logLevel: 'debug',
  frontEndUrl: 'https://webshop-b2b-dev.yllw.com',
  enableStoreDevtools: true,
  devtoolsMaxAge: 25,
  devtoolsLogOnly: false,
  signInLoadingTimeMs: 0,
};
